<template>
  <div class="header">
    <div class="top-info" v-show="$route.path == '/index'">
      <div class="main-width clearfix">
        <div class="float-left">1分钟了解此平台</div>
        <div class="float-right">
          <div class="float-left">
            <span>汽车品牌：</span>
            <span style="color: #f03">200+ （国产/合资/进口 ）</span>
          </div>
          <div class="float-left">
            <span>覆盖车型：</span>
            <span style="color: #f03">5863款</span>
          </div>
          <div class="float-left">
            <span>零件品牌数：</span>
            <span style="color: #f03">23</span>
          </div>
          <div class="float-left">
            <span>SKU数量：</span>
            <span style="color: #f03">568414</span>
          </div>
          <div class="float-left"></div>
        </div>
      </div>
    </div>
    <div class="header-info">
      <div class="clearfix main-width">
        <a href="./">
          <img class="float-left logo" alt="51autoparts" src="@assets/images/logo-big.png" />
        </a>
        <Search style="margin-top: 5px"></Search>
        <ul class="ap-list clearfix float-right" style="margin-top: 10px">
          <li class="float-left msg-wrap">
            <router-link to="/buyer/message">
              <img src="@assets/icons/u129.svg" style="height: 24px" alt />
              <span>消息</span>
            </router-link>
            <div v-if="msgCount" class="count">
              <div class="text">
                <div class="num">{{ msgCount }}</div>
              </div>
            </div>
          </li>
          <li class="float-left">
            <router-link to="/buyer/order">
              <img src="@assets/icons/file.png" style="height: 32px" alt />
              <span>订单</span>
            </router-link>
          </li>
          <li class="float-left shop-cart">
            <router-link to="/shoppingCar">
              <img src="@assets/icons/shoppingcar.png" style="height: 32px" alt />
              <span>采购车</span>
            </router-link>
            <transition name="fade">
              <div v-show="showCart" class="wrapper">
                <div class="trigon">
                  <div class="inner"></div>
                </div>
                <div class="box">
                  <div class="title">商品已加入采购车</div>
                  <div v-for="(it, idx) in cart" :key="idx" class="content clearfix">
                    <img v-if="it.fileUri" :src="it.fileUri" alt />
                    <img v-else src="@assets/images/no_image.png" alt />
                    <div class="left">
                      <strong class="text">{{ it.name }}</strong>
                    </div>
                    <div class="right">
                      <div>
                        <strong>￥&nbsp;</strong>
                        <strong style="color: #f04">{{ (it.price * it.layQty * it.qty) | toMoney }}</strong>
                      </div>
                      <div class="count">
                        <strong style="color: #f04">{{ it.layQty * it.qty }}</strong>
                        <strong>&nbsp;件</strong>
                      </div>
                    </div>
                  </div>
                  <div class="wrap">
                    <router-link tag="div" to="/shoppingCar" class="shopcart">
                      <span>打开我的采购车&nbsp;&nbsp;</span>
                      <span class="oi oi-chevron-right"></span>
                    </router-link>
                  </div>
                </div>
              </div>
            </transition>
          </li>
          <li v-if="hasLogin" class="float-left acc-info">
            <router-link to="/buyer">
              <img class="viewHead" v-if="profile.wechatNickname" :src="headImgUrl" />
              <img class="viewHead" v-else src="@assets/icons/user.png" />
            </router-link>
            <a style="margin-left: 10px" @click="logout">退出登录</a>
          </li>
          <li v-else class="float-left acc-info">
            <a @click="login">立即登录</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Search from "@components/Search.vue";
import Dropdown from "@components/Dropdown.vue";
import { mapState } from "vuex";

export default {
  components: {
    Search,
    Dropdown,
  },
  data() {
    return {
      profile: {},
      hasLogin: false,
      userName: "",
      password: "",
      msgCount: "",
    };
  },
  computed: {
    ...mapState(["showCart", "cart", "headImgUrl"]),
  },
  watch: {
    userName(newVal, oldVal) {
      if (newVal.length > 11) this.userName = oldVal;
    },
  },
  created() {
    this.bindEvents();
    var userName = localStorage._userNameMall;
    if (userName) this.userName = userName;
    document.title = "汽配供应链";
    if (this.Cookies.get("refreshToken")) {
      this.hasLogin = true;
      this.getProfile();
      this.getMsgCount();
    }
  },
  methods: {
    bindEvents() {
      this.$root.eventBus.$on("refreshMsgCount", this.getMsgCount);
      window.addEventListener("storage", (e) => {
        if (e.key === "msgCount") this.msgCount = Number(e.newValue);
      });
    },
    login() {
      const passportUrl = process.env.VUE_APP_PASSPORT_URL;
      window.location.replace(passportUrl + "/#/login?redirectUrl=" + encodeURIComponent(location.href));
    },
    logout() {
      this.Cookies.remove("token", { domain: process.env.VUE_APP_MAIN_DOMAIN });
      this.Cookies.remove("refreshToken", { domain: process.env.VUE_APP_MAIN_DOMAIN });
      window.location.reload();
    },
    getProfile() {
      this.$get("/spms/myProfiles/getProfile")
        .then((res) => {
          this.profile = res;
          if (res.wechatNickname) this.getHeadImg();
        })
        .catch((err) => {});
    },
    getHeadImg() {
      this.$post(
        "/spms/wechat/getHeadImg/",
        { userId: this.profile.id },
        {
          axios: {
            responseType: "blob",
          },
        }
      )
        .then((res) => {
          let headImgUrl = window.URL.createObjectURL(new Blob([res]));
          this.$store.commit("changeHeadImgUrl", headImgUrl);
        })
        .catch((err) => {});
    },
    getMsgCount() {
      if (!window.refreshToken) return;
      this.$post("/shared/notification/query/unread", { _offset: 0, _limit: 1 })
        .then((res) => {
          this.msgCount = res.total;
          localStorage.msgCount = res.total;
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.msg-wrap {
  margin-top: 4px;
  position: relative;
  .count {
    position: absolute;
    background: #fff;
    width: 20px;
    height: 15px;
    left: 6px;
    top: -10px;
    text-align: center;
    .text {
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      font-size: 12px;
      background: #ea6759;
      color: #fff;
      .num {
        margin-top: -1px;
      }
    }
  }
}
.login-wrap {
  padding: 16px;
  color: #999;
  font-family: "宋体";
  .item {
    border: 1px solid rgba(204, 204, 204);
    padding: 5px 10px;
    margin-bottom: 10px;
    font-size: 12px;
    .ipt {
      border: none;
      width: 200px;
      padding-left: 20px;
      font-size: 14px;
    }
  }
  .login {
    border-radius: 3px;
    text-align: center;
    background: #e10000;
    color: #fff;
    font-size: 14px;
    padding: 7px;
    margin-bottom: 15px;
    cursor: pointer;
    &:hover {
      background: #ff0000;
    }
  }
  .text {
    cursor: pointer;
    text-decoration: underline;
    &:hover {
      color: #ff0000;
    }
  }
}
.shop-cart {
  position: relative;
  .wrapper {
    position: absolute;
    z-index: 99;
    top: 55px;
    left: -220px;
    .trigon {
      position: absolute;
      left: 220px;
      top: -22px;
      z-index: 100;
      width: 25px;
      height: 25px;
      padding-top: 15px;
      overflow: hidden;
      background: #fff;
      .inner {
        width: 25px;
        height: 25px;
        box-shadow: #e4e4e4 0 0 3px 3px;
        transform: rotate(45deg);
      }
    }
    .box {
      background: #fff;
      box-shadow: #e4e4e4 0 0 3px 3px;
      border-radius: 3px;
      width: 320px;
      .title {
        color: #333;
        padding: 10px 0;
        margin: 0 10px;
        font-size: 12px;
        font-weight: 700;
        position: relative;
        border-bottom: 1px solid #e4e4e4;
      }
      .content {
        padding: 10px;
        font-size: 12px;
        img {
          float: left;
          margin-right: 10px;
          width: 50px;
          max-height: 50px;
        }
        .left {
          float: left;
          .text {
            width: 130px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
        .right {
          float: right;
          text-align: right;
          .count {
            margin-top: 12px;
          }
        }
      }
      .wrap {
        padding: 12px;
        .shopcart {
          font-size: 12px;
          line-height: 32px;
          cursor: pointer;
          background: #ed1b23;
          border-radius: 3px;
          color: #fff;
          text-align: center;
          .oi {
            vertical-align: text-top;
            width: 18px;
            height: 18px;
            background: #fff;
            border-radius: 50%;
            color: #ed1b23;
            padding: 3px 5px 7px;
          }
        }
      }
    }
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transform: translateY(-100%) scale(0.1);
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.4s ease;
  }
}
</style>

<style lang="less" scoped>
.header {
  position: fixed;
  z-index: 999;
  border-bottom: 1px solid #ebebeb;
  background: #fff;
  width: 100%;
  top: 0;
  .top-info {
    padding: 4px 0;
    background: #f2f2f2;
    font-size: 12px;
    color: #666;
    .float-left {
      margin-left: 50px;
    }
  }
  .header-info {
    padding: 20px 0;
    .logo {
      width: 200px;
    }
    .ap-search {
      float: left;
      margin-left: 80px;
    }
    > .main-width > .ap-list {
      li + li {
        margin-left: 30px;
      }
      a {
        color: #666;
      }
    }
    .acc-info {
      height: 40px;
      padding: 5px 0 0 30px;
      border-left: 1px solid #e4e4e4;
      .nav-link {
        padding-top: 1px;
        padding-left: 0;
      }
      a {
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .dd {
      padding: 12px 12px 20px;
      font-size: 12px;
      a {
        color: #333;
      }
    }
    .ap-account-menu {
      padding-left: 20px;
      margin-top: 15px;
      border-top: 1px dashed #ccc;
      li {
        width: 50%;
        margin-top: 25px;
        margin-left: 0 !important;
        img {
          height: 29px;
        }
      }
    }
  }
  .viewHead {
    width: 40px;
    height: 40px;
    margin-top: -10px;
    border-radius: 50%;
  }
}
</style>